import React, { PureComponent } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

class BreakdownTabs extends PureComponent {
  render() {
    const { status } = this.props;

    const tabs = [
      {
        title: 'Nie rozpoczęte',
        url: 'not_opened',
        status: 0,
      },
      {
        title: 'Otwarte',
        url: 'opened',
        status: 1,
      },
      {
        title: 'W trakcie',
        url: 'in_progress',
        status: 2,
      },
      {
        title: 'Zakończone',
        url: 'closed',
        status: 3,
      },
      {
        title: 'Wszystkie',
        url: 'all',
        status: 4,
      },
    ];

    return (
      <div className="row m-0 pt-3 pb-2">
        {tabs.map((item, index) => (
          <div className="card" key={index}>
            <div className="card-body">
              {item.status === status ? (
                <NavLink
                  className="breadcrumb-item active"
                  to={`/breakdowns/${item.url}`}
                >
                  {item.title}
                </NavLink>
              ) : (
                <NavLink to={`/breakdowns/${item.url}`}>{item.title}</NavLink>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

BreakdownTabs.propTypes = {
  status: PropTypes.number.isRequired,
};

export default withRouter(BreakdownTabs);
